import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpDisableCalendar = (setIsCalendarEnabled: (val: boolean) => void) => {
    const { t } = useTranslation('newNotifications');
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);

    const exec = (rejectionReason?: string) => {
        const { exec, abort } = userApi.googleCalendarDisable({
            body: { rejectionReason },
            onSuccess: _ => {
                toastHandler.push('success', t('googleIntegration.enableDisableCalendarTitle'), t('googleIntegration.disableCalendarSuccess'));
                setIsCalendarEnabled(false);
            },
            onError: () => toastHandler.push('error', t('googleIntegration.enableDisableCalendarTitle'), t('googleIntegration.disableCalendarError')),
        });
        exec();
        return abort;
    };
    return { exec };
};

export default useHttpDisableCalendar;
